import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  OnInit
} from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CompanyComplianceType } from 'src/app/classes/models/company-compliance-type';
import { CompanyService } from 'src/app/services/company.service';
import { ToastService } from 'src/app/services/toast.service';
import { UtilityService } from 'src/app/services/utility.service';

@Component({
  selector: 'app-select-compliance-program-modal',
  templateUrl: './select-compliance-program-modal.component.html',
  styleUrls: ['./select-compliance-program-modal.component.less'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class SelectComplianceProgramModalComponent implements OnInit {
  constructor(
    private activeModal: NgbActiveModal,
    private ToastService: ToastService,
    private CompanyService: CompanyService,
    private UtilityService: UtilityService,
    private cdr: ChangeDetectorRef
  ) {}

  @Input() CompanyId?: number;
  @Input() CompanyComplianceTypeId?: number;
  CompanyComplianceTypes: CompanyComplianceType[] | null = null;

  close() {
    this.activeModal.dismiss('Cross Click');
  }

  closeModal(result?: any) {
    this.activeModal.close(result);
  }

  submit() {
    if (!this.CompanyComplianceTypeId) {
      throw this.ToastService.addErrorToast(
        'Error',
        'Cannot Select CompanyComplianceType. No Compliance Type ID Selected.',
        { returnError: true }
      );
    }
    this.closeModal(this.CompanyComplianceTypeId);
  }

  ngOnInit(): void {
    if (!this.CompanyId) {
      this.activeModal.close();
      throw this.ToastService.addErrorToast(
        'Error',
        'Cannot Select CompanyComplianceType. No Company ID found.',
        { returnError: true }
      );
    }

    this.CompanyService.getCompanyComplianceTypes(
      this.UtilityService.stringifyObjectsInQueryObject({
        attributes: ['id', 'type'],
        CompanyId: this.CompanyId
      })
    ).subscribe({
      next: (CompanyComplianceTypes: CompanyComplianceType[]) => {
        if (CompanyComplianceTypes.length === 1) {
          this.closeModal(CompanyComplianceTypes[0].id);
          return;
        }

        this.CompanyComplianceTypes = CompanyComplianceTypes;
        this.cdr.markForCheck();
      }
    });
  }
}
